import { render, staticRenderFns } from "./seasonMatch.vue?vue&type=template&id=01f012b2&scoped=true"
import script from "./seasonMatch.vue?vue&type=script&lang=js"
export * from "./seasonMatch.vue?vue&type=script&lang=js"
import style0 from "./seasonMatch.vue?vue&type=style&index=0&id=01f012b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f012b2",
  null
  
)

export default component.exports